import { render, staticRenderFns } from "./AddIncidentRound.vue?vue&type=template&id=3dd8f965&scoped=true&"
import script from "./AddIncidentRound.vue?vue&type=script&lang=js&"
export * from "./AddIncidentRound.vue?vue&type=script&lang=js&"
import style0 from "./AddIncidentRound.vue?vue&type=style&index=0&id=3dd8f965&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8f965",
  null
  
)

export default component.exports